import type { StacksUtilState } from './types';

const initialState: StacksUtilState = {
  allCommands: [],
  currCommand: '',
  isAllCommandsLoading: false,
  isRunCommandSuccess: false,
  error: {
    allCommandsError: false,
    runCommandError: false,
  },
  userNumber: null,
};

export default initialState;
